// @ts-nocheck
import {
  buildColumnMap,
  buildNormalizedAliases,
  buildStandardRecord,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const DONGKOO_BIO_FIELD_ALIASES = {
  customerName: ['처방처명'],
  drugCode: ['처방품목코드'],
  drugName: ['품명'],
  unitPrice: ['단가'],
  quantity: ['수량'],
  prescriptionAmount: ['처방금액'],
  feeRate: ['수수료지급율'],
  settlementAmount: ['수수료금액'],
  note: ['비고'],
};

const REQUIRED_HEADERS = [
  '구간제외=1',
  '소액처=1',
  '관리유형',
  '법인코드',
  '법인명',
  '담당자코드',
  '담당자명',
  '처방처코드',
  '사업자번호',
  '처방처명',
  '등급',
  '처방품목코드',
  '품명',
  'seq',
  '수량',
  '단가',
  '처방금액',
  '수수료지급율',
  '수수료금액',
  '이전년월',
  '비고',
  '보류',
];

const DONGKOO_HEADER_ROW_INDEX = 1;
const DONGKOO_DATA_START_INDEX = 2;

function isDongkooBioProfile(profile) {
  return (
    normalizeHeader(profile.sheetName).startsWith(
      normalizeHeader('처방수수료'),
    ) &&
    REQUIRED_HEADERS.every((header) =>
      profile.headers.some(
        (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
      ),
    )
  );
}

const dongkooBioTemplate = {
  id: 'dongkoo-bio',
  name: '동구바이오 템플릿',
  match(context) {
    return context.headerProfiles.some(isDongkooBioProfile);
  },
  extract(context) {
    const targetProfile = context.headerProfiles.find(isDongkooBioProfile);
    if (!targetProfile) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const sheetName = targetProfile.sheetName;
    const rows = context.sheetRowsMap[sheetName] || [];
    const headerRow = rows[DONGKOO_HEADER_ROW_INDEX] || [];
    const columnMap = buildColumnMap(
      headerRow,
      buildNormalizedAliases(DONGKOO_BIO_FIELD_ALIASES),
    );
    const extractedRows = [];

    rows.slice(DONGKOO_DATA_START_INDEX).forEach((row, rowOffset) => {
      if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
        return;
      }

      const drugCode = cleanText(row[columnMap.drugCode]);
      if (!drugCode) {
        return;
      }

      const record = buildStandardRecord({
        fileName: context.file.name,
        sheetName,
        rowIndex: DONGKOO_DATA_START_INDEX + rowOffset,
        templateId: this.id,
        detectedPharmaceuticalCompany: '동구바이오',
        customerName: row[columnMap.customerName],
        drugCode,
        drugName: row[columnMap.drugName],
        unitPriceValue: row[columnMap.unitPrice],
        quantityValue: row[columnMap.quantity],
        prescriptionAmountValue: row[columnMap.prescriptionAmount],
        feeRateValue: row[columnMap.feeRate],
        settlementAmountValue: row[columnMap.settlementAmount],
        note: row[columnMap.note],
      });

      if (shouldSkipRecord(record, row)) {
        return;
      }

      extractedRows.push(record);
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: '동구바이오',
      templateName: this.name,
    };
  },
};

export default dongkooBioTemplate;
